// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { ExecutedPauseStateChange } from '@daml.js/dtc-registry/lib/Dtc/Registry/V3/Model/MarkerEvents';
import { TemplateHistory, useTemplateHistory } from '../../useTemplateHistory';

const usePauseHistory = (): TemplateHistory<ExecutedPauseStateChange> =>
  useTemplateHistory(ExecutedPauseStateChange);

export default usePauseHistory;
